module.exports = __webpack_public_path__ + "media/svgs/Tanzfabrik_Signet-black-bf4a0a54375c0a1b8e0451a707af63c0.svg";